var serialize = function(obj) {
    var str = []
    for (var p in obj) {
        if (p !== 'servicename' && p !== 'section') {
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
            }
        }
    }
    return str.join('&')
}

export const dashboard = {
    state: {
        sysList: []
    },
    getters: {
        getSysData: (state) => {
            return state.sysList
        }
    },
    mutations: {
        setSysList: (state, val) => {
            state.sysList = val
        }
    },
    actions: {
        listGraphListing(context, data) {
            let { section } = data
            // console.log(data, 'section')
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            }
            if (data.section) delete data.section
            if (data.servicename) delete data.servicename
            if (data.quality) data.quality[0] === "ALL" ? delete data.quality : data.quality
            if (data.drmscheme) data.drmscheme[0] === "ALL" ? delete data.drmscheme : data.drmscheme
            if (data.streamtype) data.streamtype[0] === "ALL" ? delete data.streamtype : data.streamtype
            let queryData = serialize(data)
            return new Promise((resolve, reject) => {
                fetch(`${context.getters.getbaseUrl}/provider/v1/dashboard/${section}?${queryData}`, requestOptions)
                    .then((response) => {
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            reject(response)
                        }
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        listSummaryListing(context, data) {
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            }
            return new Promise((resolve, reject) => {
                fetch(`${context.getters.getbaseUrl}/provider/v1/dashboard`, requestOptions)
                    .then((response) => {
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            reject(response)
                        }
                    }).catch(error => {
                        reject(error)
                    })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/dashboard.js